import { createAsyncThunk } from '@reduxjs/toolkit';
import { giftApiUrl } from 'Services/Apis/clients';
import axios from 'axios';

export const headersCustom = {
  Authorization: `Bearer eyJraWQiOiJWcmpOVVBGM3FhXC9DbjRsQ2dhS0dYMjl6bkNScXdESjVMR1g0XC9YQ3B2RFk9IiwiYWxnIjoiUlMyNTYifQ.eyJzdWIiOiIzYTIxZGY2OC04NTFlLTQ1ZDctOGViYy0xYTNhZjVkMzQxNTEiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtZWFzdC0xLmFtYXpvbmF3cy5jb21cL3VzLWVhc3QtMV9wTmY2MWMxbHQiLCJ2ZXJzaW9uIjoyLCJjbGllbnRfaWQiOiIxcmlybm5rcnBzb2hwNzZ1dHBqMzczdW5pbiIsImV2ZW50X2lkIjoiNWQ1ZDBjNTgtYTNlZC00OGE5LTkyY2ItZDkzNGY1NGZjNDAzIiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiBvcGVuaWQgcHJvZmlsZSBlbWFpbCB3ZWJwcmVtaW9zLmNhbXBhaWduc1wvNTA0NTgiLCJhdXRoX3RpbWUiOjE2OTg0NDI1NDYsImV4cCI6MTY5ODQ0NjE0NiwiaWF0IjoxNjk4NDQyNTQ2LCJqdGkiOiI4OGY0Zjc3My0wYmE3LTQ4NDUtYTY5MS1hMGQwYmM4MjViMjAiLCJ1c2VybmFtZSI6IjE2MTkyMTg5NzY1In0.B0DYbrgJYmtnUMVNISADiOAt3K_0ot8EEUiXfqEaX7yuVJVRHHlD0My8gMipK3sMjjdUwPcBBHVrEqGwX9wggIMNneuIWFvl9GALq2z1cIanMUaiKkLMxoIlSn5stHv_aVJhCINqnJR3ySBlUGwDafHGlzfzQ3uRQrSELzmyre7T90GBAENkVz1B6dgnBYGWcAVZSXMcS1_KQJWqXKpgnlIKeVPYgFnczyON_d4GrWa5mhMSgsQRUVlHcI6AxqH9gu6e40_a_fCPrIBCr1-iXUqlrB4AglI02cZIeGXghHuvqvULiKWlaE7GJkNiFkmrNWh7yhNYStY9df3e8DgN4w`,
  campaignId: 50458,
  catalogId: 50545,
  participantId: 31587920,
  username: 16192189765,
  'x-tenant': 50458,
  'x-cachekey': 50545,
  contentType: 'application/json',
}

export const getGiftsActiveByCampaign = createAsyncThunk(
  `giftApi/getGiftsActiveByCampaign`,
  async (_, { getState }) => {
    const { user } = getState().oidc;

    const customHeaders = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
      'x-tenant': user.profile['custom:campaign_id'],
      'x-cachekey': user.profile['custom:catalog_id'],
    };
    const response = await axios.get(
      `${giftApiUrl}/api/marketplace/gift/activeByCampaign`,
      { headers: customHeaders }
    );
    return response.data;
  });

export const getParticipantRedemptionAvailable = createAsyncThunk(
  `giftApi/getParticipantRedemptionAvailable`,
  async (param, { getState }) => {
    const { user } = getState().oidc;

    const customHeaders = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
      'x-tenant': user.profile['custom:campaign_id'],
      'x-cachekey': user.profile['custom:catalog_id'],
    };

    const response = await axios.get(
      `${giftApiUrl}/api/marketplace/gift/participantRedemptionAvailable/${param.giftId}`,
      { headers: customHeaders }
    );
    return response.data;
  });

export const giftsRedeemedByParticipant = createAsyncThunk(
  `giftApi/giftsRedeemedByParticipant`,
  async (giftId, { getState }) => {


    const { user } = getState().oidc;

    const customHeaders = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
      'x-tenant': user.profile['custom:campaign_id'],
      'x-cachekey': user.profile['custom:catalog_id'],
    };

    const response = await axios.get(
      `${giftApiUrl}/api/marketplace/redemption/getByParticipant?giftId=${giftId}`,
      { headers: customHeaders }
    );
    return response.data;
  });

export const redeemGift = createAsyncThunk(
  `giftApi/redeemGift`,
  async (body, { rejectWithValue, getState }) => {
    const { user } = getState().oidc;

    const customHeaders = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
      'x-tenant': user.profile['custom:campaign_id'],
      'x-cachekey': user.profile['custom:catalog_id'],
    };

    try {
      const response = await axios.post(
        `${giftApiUrl}/api/marketplace/redemption`,
        body,
        { headers: customHeaders }
      );
      return response.data;
    } catch (error) {
      const response = { error: true }
      throw rejectWithValue(response);
    }

  });
